import { render } from "./SearchFilterItem.vue?vue&type=template&id=085b8f0f&scoped=true"
import script from "./SearchFilterItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SearchFilterItem.vue?vue&type=script&charset=utf-8&lang=js"

import "./SearchFilterItem.vue?vue&type=style&index=0&id=085b8f0f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085b8f0f"]])

export default __exports__